import React from 'react'
import autobind from 'autobind-decorator'
import PropTypes from 'prop-types'
import track from 'App/helpers/track'

export default class DateTextField extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.any,
    useHint: PropTypes.bool,
    label: PropTypes.any,
    errorMessage: PropTypes.string,
    disabled: PropTypes.bool,
    passProps: PropTypes.object,
    track: PropTypes.object,
    fieldName: PropTypes.string
  }

  static defaultProps = {
    disabled: false
  }

  state = {text: ''}

  getValue() {
    return this.props.value || ''
  }

  replaceTexts(text, previous) {
    if (!text.includes('+') && text.length > 0) {
      this.onChange('+' + text)
      return true
    }
    if (/[^0-9+ ]+/g.test(text)) {
      this.onChange(text.replace(/[^0-9+ ]+/g, ''))
      return true
    }
    if (previous.length > text.length) return
    if (text.length === 4 || text.length === 9) {
      this.onChange(text + ' ')
      return true
    }
  }

  onChange(text) {
    if (this.replaceTexts(text, this.state.text)) return
    this.setState({text})
    this.props.onChange(text)
  }

  @autobind
  onBlur() {
    if (!this.props.value) {
      this.setState({text: ''})
    }
    this.trackBlur()
  }

  trackBlur() {
    const traceableEvent = {
      action: `entered-${this.props.fieldName}`,
      ...this.props.track
    }
    if (this.props.track) return track(traceableEvent)
  }

  render() {
    return (
      <div>
        <div className="os-input-container">
          <input
            className="os-input-text"
            value={this.getValue()}
            onChange={event => this.onChange(event.target.value)}
            onBlur={this.onBlur}
            disabled={this.props.disabled}
            {...this.props.passProps}
            maxLength="14"
            type="tel"
          />
        </div>
        <div className="os-input-error">{this.props.errorMessage}</div>
      </div>
    )
  }
}
